import React, { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import { CONSTANTS } from "../../helpers/Constant";
import { useLocation } from "react-router-dom";

const Gdpr = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <Header />
      <div className="bg-Gray-50 md:py-24 py-8">
        <div className="container xs:container sm:container md:container lg:container w-full mx-auto">
          <div className="py-8">
            <h2 className="text-4xl font-avenirHeavy text-Gray-900">
              <span className="text-blue-200">GDPR</span> &amp; Privacy Notice
            </h2>
            <span className="text-lg font-avenirHeavy text-Gray-900 pt-3 block">
              Updated: 2023-10-24
            </span>

            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-8">
              This Privacy Notice explains how information about you is
              collected, used and disclosed by {CONSTANTS.COMPANY_NAME} AB 556593-8973 when you
              use our website and other online products and services or when you
              otherwise interact with us. We may amend this Privacy Notice from
              time to time. If we make changes, we will revise the date at the
              top of the notice and, depending on the specific amendments, we
              may provide you with additional notice. We encourage you to review
              the Privacy Notice whenever you access our Services to stay
              informed about our information practices and the ways you can help
              protect your privacy.
            </p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-8">
            We value your privacy, and it is important for you to feel secure when entrusting us with your personal data. This document describes how we collect and process your personal data. It is based on applicable data protection legislation and clarifies how we collect and process personal data
            </p>
            <h3 className="py-14 text-3xl font-avenirHeavy text-Gray-900">
              1. Collection of personal data
            </h3>
            <h3 className="text-2xl font-avenirHeavy text-Gray-900">
              1.1 Collection at purchase
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-8">
              When you make a purchase with {CONSTANTS.COMPANY_NAME},{" "}
              {CONSTANTS.COMPANY_NAME} will collect your contact information.Personal data means any type of information that can be attributed to an individual. We process the following types of data about you:
            </p>
            <ul className="static-content-list">
              <li>Identity (e.g., first name, last name, and title)</li>
              <li>Contact information (e.g., email address, phone number, and billing address)</li>
              <li>
              Technical information (e.g., login, IP address, browser and version, time zone, operating system, and other information about the technology you use to visit our sites)
              </li>
              <li>Usage (e.g., how you use our sites, our social media channels, and our services)</li>
              <li>Marketing and communication data (your preferences for receiving marketing communication from us)</li>
              <li>Financial (e.g., billing and payment information)</li>
              <li>Transactions (data necessary to process payments for potential purchases, e.g., credit card number and associated security code)</li>
              <li>Purchase history (data about your purchases: amount and time of purchase)</li>
            </ul>

            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-8">
              When you wish to register certain top-level domains, we may
              require further identification like your social security number to
              be able to register the domain on behalf of you. You can help
              {CONSTANTS.COMPANY_NAME} to keep your personal information
              accurate by logging into your "{CONSTANTS.COMPANY_NAME} control
              panel". We advise you to do so every time your personal details
              change.
            </p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-8"> Note: We do not collect any sensitive data about you, such as ethnicity, religious beliefs, sexual orientation, political opinions, health data, biometric data, criminal records, or penalties</p>
            
            <h3 className="text-2xl font-avenirHeavy text-Gray-900 py-8">
              1.2 Other collection
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-2">
              When you access or use our Services, we automatically collect
              information about you, including:
            </p>
            <ul className="static-content-list">
              <li>
                Log Information: we log information about your use of our
                Services, including the type of browser you use, access times,
                pages viewed and your IP address.
              </li>
              <li>
                Information collected by cookies and other tracking
                technologies: we use various technologies to collect
                information, and this may include sending cookies to your
                computer or mobile device. Cookies are small data files stored
                on your computer’s hard drive or in device memory that help us
                to improve our Services and your experience and see which areas
                and features of our Services are popular. Please refer to our
                cookie policy (as described in section 5) for further
                information.
              </li>
              <li>
                We also collect other information you provide directly to us,
                such as when you participate in a contest and promotion, request
                customer support, send us an email or otherwise interact with
                us. The types of information we may collect about you include
                your name, email address and any other information you choose to
                provide.
              </li>
            </ul>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-2">
              When you access or use our Services, we automatically collect
              information about you, including:
            </p>

            <h3 className="pt-14 text-3xl font-avenirHeavy text-Gray-900">
              2. Use of personal data
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              We may use information about you for various purposes, including
              to:
            </p>
            <ul className="static-content-list">
              <li>Provide, maintain and improve our current Services;</li>
              <li>
                Respond to your comments, questions and requests and provide
                customer service and support;
              </li>
              <li>
                Send you technical notices, updates, security alerts and support
                and administrative messages;
              </li>
              <li>
                Communicate with you about products, services, offers,
                promotions and events offered by {CONSTANTS.COMPANY_NAME};
              </li>
              <li>Improve our Services;</li>
              <li>Process and deliver contests and rewards;</li>
              <li>
                Monitor and analyse trends, usage and activities relating to our
                Services;
              </li>
            </ul>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              We may share information about you as follows or as otherwise
              described in this Privacy Notice:
            </p>
            <ul className="static-content-list">
              <li>
                In response to a request for information if we believe
                disclosure is in accordance with any applicable legal
                requirement;
              </li>
              <li>
                If we believe your actions are inconsistent with the spirit or
                language of our terms or policies, or to protect the rights,
                property and safety of {CONSTANTS.COMPANY_NAME} or others;
              </li>
              <li>To report abuse or clearly illegal activity;</li>
              <li>
                In connection with, or during negotiations of, any merger, sale
                of company assets, financing or acquisition of all or a portion
                of our business to another company; and
              </li>
              <li>
                We also may share aggregated information or otherwise anonymised
                information, which cannot reasonably be used to identify you.
              </li>
              <li>
                Our Services may offer social sharing features and other
                integrated tools (such as the Facebook "Like button"), which let
                you share actions you take on our Services with other media, and
                vice versa. The use of such features enables the sharing of
                information with your friends or the public, depending on the
                settings you establish with the entity that provides the social
                sharing feature. For more in-formation about the purpose and
                scope of data collection and processing relating to social
                sharing features, please visit the privacy policies of the
                entities that provide these features.
              </li>
            </ul>
            <h3 className="pt-14 text-3xl font-avenirHeavy text-Gray-900">
              3. Recipients of your personal data
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              "Your personal data" are the data we collect about you upon
              purchase (as described in section 1.1) and other collection (as
              described in section 1.2.).
            </p>
            <h3 className="text-2xl font-avenirHeavy text-Gray-900 pt-8">
              3.1 Disclosure to domain name authorities
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              As part of our obligations as a domain name registrar,{" "}
              {CONSTANTS.COMPANY_NAME} is required to provide certain
              information to naming authorities around the world about customers
              who register domain names at
              {CONSTANTS.COMPANY_NAME}. ion 1.1) and other collection (as
              described in section 1.2.).
            </p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              This information will vary according to the guidelines from the
              domain name authority. As a general rule, the data we provide
              includes your contact details (name and address), but may also
              include your e-mail, telephone number and date of birth. The
              relevant naming authority may make such information available for
              the public through open, accessible directories of domain name
              owners, so called “whois”.
            </p>
            <h3 className="text-2xl font-avenirHeavy text-Gray-900 pt-8">
              3.2 Disclosure of data to courts or authorities
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              Your data (customer data) is any information you have placed on
              your web space at {CONSTANTS.COMPANY_NAME}, for example emails,
              internet pages, photos and database content.{" "}
              {CONSTANTS.COMPANY_NAME} does not form any opinion or perform any
              legal review of your data (the customer data) on your web space
              account. We refer to our for further info on disclosure to courts
              or authorities as well.
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              4. Deletion of personal data
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              We will delete your personal data when we no longer need to
              process them in relation to one or more of the purposes set out
              above.
            </p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              Generally, we will store your personal for as long as there is
              still an active subscription and when required to deliver the
              service and support. Otherwise we will store your personal data
              for up to 1 year or longer if legal requirements demand us to do
              so.
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              5. International transfers
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
            When we share your personal data with a third party in accordance with what is stated in this privacy policy, your personal data may be transferred to a state that is not a member of the EU or EEA. This privacy policy also applies when we transfer personal data to other countries.
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              6. Cookies
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
            At www.2MNordic.com and our other websites, we use cookies.
            </p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              A cookie file is part of a text that - with your consent - can be
              placed in your computer’s hard drive. Your browser will then add
              the text in a separate file. {CONSTANTS.COMPANY_NAME} uses cookies
              to facilitate the traffic analyses on our websites by accessing
              information about who has visited a certain website at a certain
              time. In the settings of your browser, you can choose to accept
              cookies or not. You are also able to erase cookie files that have
              been placed in your hard drive. up to 1 year or longer if legal
              requirements demand us to do so.
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              7. Security
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              We have implemented security measures to ensure that our internal
              procedures meet our high security policy standards. Accordingly,
              we strive to protect the quality and integrity of your personal
              data. This includes encryption of data.
            </p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              It also includes physical and logical access control, backup,
              logs, encrypted communications and other measures to mitigate
              risks.
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              8. Your rights
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              You are at any time entitled to be informed of the personal data
              about you that we process, but with certain legislative
              exceptions. You also have the right to object to the collection
              and further processing of your personal data including
              profiling/automated decision-making. Furthermore, you have the
              right to have your personal data rectified, erased or blocked.
              Moreover, you have the right to receive information about you that
              you have provided to us, and the right to have this information
              transmitted to another data controller (data portability).
            </p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              If you wish to know more and/or exercise any of these rights,
              please contact {CONSTANTS.COMPANY_NAME} (support@2mnordic.com).
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              9. Storage of personal data
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">We protect your personal data from unauthorized access, use, or disclosure. For example, personal data you provide is stored on computer systems with limited access and in secure facilities. When transmitting highly sensitive data (e.g., credit card numbers and passwords) over the internet, we protect it with encryption.</p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">We may store your personal data in our own technology and through cloud services, with third parties contracted to support our business operations. These third-party organizations do not process your personal data and do not have access to it, except for cloud storage and access by us. We require these third parties to apply at least the same level of IT security as we use to protect your personal data.</p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">In general, personal data processing takes place within the EU/EEA. In some cases, we may use suppliers established outside the EU/EEA. When personal data processing occurs outside the EU/EEA, it is done with legal support through an EU Commission decision that the country provides an adequate level of protection for the processing of personal data, or other appropriate security measures are in place.</p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">We store personal data for as long as necessary for the purposes for which they are used, such as providing the Services, maintaining and improving existing Services, sending necessary and marketing communication, and fulfilling our legal obligations. Since the needs may vary for different types of data and for different types of Services and contexts, the period we store data varies.</p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">The criteria for determining how long personal data will be saved include:</p>
            <ul className="static-content-list">
              <li>
              The purpose of using the data; data used to fulfil legal requirements is stored longer than, for instance, contact information for direct marketing.
              </li>
              <li>How the data is stored; data that is not pseudonymized is stored for a shorter time than pseudonymized data.</li>
              <li>
              The relationship we have with you; whether you are a current, former, or potential user/customer, or if you visit our site without being logged in.
              </li>
            </ul>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">We have the right to use your contact information for direct marketing during the time we have a user or customer relationship, and for a certain time after our user or customer relationship ends, as long as you do not object to it. We retain your data for up to 36 months after the Service has ended.</p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">We may contact potential customers by phone or email to market our Services. If you choose not to establish a customer relationship with us, we retain the contact information for up to 24 months from the date of contact.</p>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">Your personal data will be deleted or anonymized when they are no longer relevant for the purposes for which they were collected. Your personal data is stored longer than what is stated above if we are required by law to do so or to retain data that must be retained to resolve a dispute, or if you have consented to it. We use your data for marketing only if allowed by law and you have not objected to it.</p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              10. Changes to this Privacy Policy
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
            We update our privacy policy as needed to reflect customer feedback and changes in our Services. When the policy is updated, the date of the latest update at the top of the policy will change.
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              11. Third party actors
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
            2MNordic uses third-party actors for certain tasks and to store personal data and related data. This is necessary to provide you, as a customer, with the best possible services, follow-up, and customer experience. We are data controllers and responsible for all stored data.
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              12. Withdrawal of consent
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              You may, at any time, withdraw any consent you have given and we
              will no longer process your personal data, unless we can continue
              the processing based on another purpose. If you wish to withdraw
              your consent, please contact {CONSTANTS.COMPANY_NAME}{" "}
              (support@2mnordic.com).
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              13. Amendment of data, etc.
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              If you want us to update, amend or delete the personal data that
              we process about you, if you wish to get access to the data, or if
              you have any questions concerning the above guidelines, you may
              contact {CONSTANTS.COMPANY_NAME} (support@2mnordic.com).
            </p>
            <h3 className="text-3xl font-avenirHeavy text-Gray-900 pt-14">
              14. Complaints
            </h3>
            <p className="text-base font-opensans leading-relaxed text-Gray-600 py-4">
              If you wish to appeal against the processing of your personal
              data, please contact us as indicated above.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Gdpr;
